import classNames from 'classnames';

/**
 * `cn` — thin alias over `classnames` so components import from one place.
 * Centralising this lets us swap implementations (e.g. to tailwind-merge) later.
 */
export const cn = classNames;
export default cn;
